import { executeRequest, Request } from '@jfs/network'
import { AESEncryption, getRandomAlphaNumString, RSAEncryption } from '@jfs/utils'
import { getNetworkResponseError, isStatusSuccess } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
import { COUNTRY_CODE, ENTITY_TYPE, MODE, PURPOSE } from './LoginReq'

const REQUEST = 'REQUEST'
const verify = 'verify'

const responseParser = (data: any) => {
  return data
}

const verifyOtpBody = (mobileNumber: string, encOtp: string, encryptionKey: string, mode: number,
  purpose: number, amount?: any) => {
  return {
    user: {
      mobile: {
        mobileNumber: mobileNumber,
        countryCode: COUNTRY_CODE,
      },
      emailAddress: '',
      entityType: ENTITY_TYPE,
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: mode ?? MODE,
        value: encOtp,
        action: verify,
      },
    ],
    secure: {
      encryptionKey: encryptionKey,
    },
    purpose: purpose ?? PURPOSE,
    extraInfo: mobileNumber,
  }
}

const verifyDeleteBeneBody = (mobileNumber: string, encOtp: string, encryptionKey: string, mode: number,
  purpose: number, amount?: any) => {
  console.log(mobileNumber, "ch%eckmobile::")
  return {
    user: {
      mobile: {
        mobileNumber: mobileNumber,
        countryCode: COUNTRY_CODE,
      },
      emailAddress: '',
      entityType: ENTITY_TYPE,
    },
    scope: "REQUEST",
    authenticateList: [
      {
        mode: mode ?? MODE,
        value: encOtp,
        action: verify,
      },
    ],
    secure: {
      encryptionKey: encryptionKey,
    },
    purpose: purpose ?? PURPOSE,
    extraInfo: mobileNumber,
  };
};

const validateOtpApi = (otp: string, mobileNumber: string, tokens: any, options?: { mode?: number; purpose?: number, amount?: any }) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY

  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)

  const request: Request<{}> = {
    apiPath: APIEndPoints.userAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: verifyOtpBody(mobileNumber, encOtp, encryptionKey, options?.mode, options?.purpose, options?.amount),
    headers: {
      'Content-Type': 'application/json',
    },
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      if (data?.data?.status === 'SUCCESS' && isStatusSuccess(data?.data)) {
        sendEventApi(tokens, request, {
          status: 'SUCCESS',
        })
        return responseParser(data)
      } else {
        throw getNetworkResponseError(data?.data)
      }
    })
    .catch((error) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: error,
      })
      throw error
    })
}

export const verifyDeleteBeneOtpApi = (otp: string, mobileNumber: string, tokens: any, options?: { mode?: number; purpose?: number, amount?: any }) => {
  const { REACT_APP_JFS_PUBLIC_KEY } = process.env;
  const PUBLIC_ENC_KEY: any = REACT_APP_JFS_PUBLIC_KEY;
  let randomEncryptionKey = getRandomAlphaNumString(32);
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY);
  let encOtp = AESEncryption(randomEncryptionKey, otp);

  const request: Request<{}> = {
    apiPath: APIEndPoints.userAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: verifyDeleteBeneBody(mobileNumber, encOtp, encryptionKey, options?.mode, options?.purpose, options?.amount),
    headers: {
      'Content-Type': 'application/json',
    },
  };
  sendEventApi(tokens, request, { status: 'INITIATED' });
  return executeRequest(request)
    .then((data) => {
      if (data?.data?.status === 'SUCCESS' && isStatusSuccess(data?.data)) {
        sendEventApi(tokens, request, { status: 'SUCCESS' });
        return responseParser(data);
      } else {
        throw getNetworkResponseError(data?.data);
      }
    })
    .catch((error) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: error,
      });
      throw error;
    });
};

export { validateOtpApi }

